import { render, staticRenderFns } from "./PersonalityBannerSection.vue?vue&type=template&id=548ba2e2"
import script from "./PersonalityBannerSection.vue?vue&type=script&lang=ts"
export * from "./PersonalityBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./PersonalityBannerSection.vue?vue&type=style&index=0&id=548ba2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports